import initializeForm from './initializeForm';
import setIsNewRecord from './setIsNewRecord';
import toggleModal from './toggleModal';

export default (item) => (dispatch) => {
    dispatch(initializeForm(item));
    dispatch(setIsNewRecord(false));
    dispatch(toggleModal(true));
};
